import { useCallback } from "react";
import { VariaveisAmbiente } from "../../../../config";
import { useApiBase } from "../../base/api-base";

export function useGetPedidoById() {
    const { invocarApi, ...outrasPropriedades } = useApiBase();

    const getPedidoById = useCallback(
        (empresaId: string, pedidoId: string) => {
            return invocarApi({
                url: `/${VariaveisAmbiente.pedidosVersion}/empresa/${empresaId}/pedido-salao/${pedidoId}`,
                method: "GET",
                baseURL: `${VariaveisAmbiente.apiPedidosUrl}/api`,
                enviarTokenUsuario: true,
            });
        },
        [invocarApi]
    );

    return {
        ...outrasPropriedades,
        getPedidoById,
    };
}